import { STORE_CHIPS } from "@/lib/affiliate-ui";
import { cn } from "@/lib/utils";

interface StoreChipsProps {
  /** Loja detectada no link colado (destaca o chip). */
  readonly activeCode: string | null;
}

/** Chips das lojas suportadas; a detectada fica destacada. */
export function StoreChips({ activeCode }: StoreChipsProps): JSX.Element {
  return (
    <ul className="flex flex-wrap gap-2" aria-label="Lojas suportadas">
      {STORE_CHIPS.map((chip) => {
        const isActive = chip.code === activeCode;
        return (
          <li
            key={chip.code}
            aria-current={isActive ? "true" : undefined}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors",
              isActive
                ? "border-primary/50 bg-primary/15 text-primary"
                : "border-border bg-[hsl(var(--surface)/0.7)] text-muted-foreground",
            )}
          >
            {isActive && <span className="h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />}
            {chip.label}
          </li>
        );
      })}
    </ul>
  );
}
